import {
  VENUE_USER_LIST_QUERY,
  useVenueUserCreateMutation,
} from "@ticketingplatform/api/dist/venueUser";
import { Form, message } from "antd";
import { useVenueContext } from "contexts/VenueContext";
import useApolloErrorFields from "hooks/useApolloErrorFields";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { useMemo } from "react";
import { ROUTE_PATHS } from "const/paths";
import usePrompt from "hooks/usePrompt";

import { UserFormProps } from "../../Users/UserForm/types";

import { VENUE_USER_INITIAL_VALUES } from "./consts";

export const useVenueUserCreateForm = (): UserFormProps<true> => {
  const intl = useIntl();
  const [form] = Form.useForm();
  const { venue } = useVenueContext();
  const navigate = useNavigate();
  const [venueUserCreateMutation, { loading, error }] =
    useVenueUserCreateMutation({
      evictQueries: [VENUE_USER_LIST_QUERY],
    });
  const fields = useApolloErrorFields(error);

  usePrompt(loading);

  return useMemo(
    () => ({
      form,
      fields,
      loading,
      isVenueUser: true,
      initialValues: VENUE_USER_INITIAL_VALUES,
      async onFinish({ input: { firstName, lastName, role, phoneNumber } }) {
        try {
          await venueUserCreateMutation({
            variables: {
              input: {
                firstName,
                lastName,
                role,
                phoneNumber,
                venueId: venue?.id,
              },
            },
          });

          message.success(
            intl.formatMessage({
              defaultMessage: "User has been added!",
            })
          );

          navigate(ROUTE_PATHS.SettingsVenueUserList, {
            state: {
              skipBlock: true,
            },
          });
        } catch {
          message.error(
            intl.formatMessage({
              defaultMessage: "Error. Cannot add User.",
            })
          );
        }
      },
    }),
    [fields, form, intl, loading, navigate, venue?.id, venueUserCreateMutation]
  );
};
